import { render, staticRenderFns } from "./CatalogoContratos.vue?vue&type=template&id=135763a5&scoped=true"
import script from "./CatalogoContratos.vue?vue&type=script&lang=js"
export * from "./CatalogoContratos.vue?vue&type=script&lang=js"
import style0 from "./CatalogoContratos.vue?vue&type=style&index=0&id=135763a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135763a5",
  null
  
)

export default component.exports